export const PROVIDER_CODE_ELAP = 'ELAP API';
export const PROVIDER_CODE_DOL  = 'DOL API';
